import React, { Component } from "react";
import TodoDataService from '../../hooks/services'

// -----------Importar Componentes de Terceros------------------
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';


class Blog extends Component {
  state = {
    Error: '',
  }


  render() {
    return (
     <Box  sx={{margin:{xs:'100% 0%', sm:'20% 0%'}}}> 
      <Container sx={{padding:'0px !important', maxWidth:'1080px !important'}}>

        <Typography color='#D14081 !important' textAlign='center' variant="h1" fontSize='42px'>
          Disponible próximamente
        </Typography>
     
      </Container>

    
       </Box>
    );
  }
}

export default Blog;

